<template lang="pug">
.section
  .section-header
    template(v-if="!selectedOperatorID")
      h1 {{ $t("ui.daily_ledger_operator") }}
    template(v-else)
      .section-header-back
        a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
      h1 {{ getPageName(mode) }}
      .section-header-breadcrumb
        .breadcrumb-item
          a(href="javascript:void(0);" @click="redirect()") {{ $t("ui.daily_ledger_operator") }}
        .breadcrumb-item.active
          span {{ getPageName(mode) }}
  .section-body
    .row
      .col-12
        template(v-if="selectedOperatorID")
          template(v-if="mode == 1")
            uniqueLogin(ref="uniqueLogin" :id="selectedOperatorID" :date="dateRange")
          template(v-else-if="mode == 2")
            uniqueWithdrawal(ref="uniqueWithdrawal" :id="selectedOperatorID" :date="dateRange")
          template(v-else-if="mode == 3")
            secondDeposit(ref="secondDeposit" :id="selectedOperatorID" :date="dateRange")
          template(v-else)
            dailyLedgerMember(ref="dailyLedgerMember" :id="selectedOperatorID" :date="dateRange")
        template(v-else)
          .card.mb-0
            .card-header
              .row.w-100
                .form-group.col-md-12.col-lg-6.col-xl-3.col-12.mb-1(v-if="!isOperator")
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-user
                    DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getList(true)" size="sm")
                .form-group.col-md-12.col-lg-12.col-xl-5.col-12.mb-1
                  DateRangePicker(:value="dateRange" @update="getData")
                .form-group.col-12.mb-1
                  SubmitButton(
                    icon="fa fa-search"
                    :loading="loading"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getList(true)"
                    variant="primary"
                    size="sm"
                  ).mr-2
                  jsonToExcelFull(v-if="statementList.length > 0" mode="DailyLedgerOperator" :dttbl="statementList" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_one").mr-2
                  jsonToExcelFull(v-if="statementListFull.length > 0 && $helpers.showExportAll(dateRange) == true" mode="DailyLedgerOperator" :dttbl="statementListFull" :date="dateRange" type="1" :loading2="loading2" btnTxt="export_all")
            .card-body
              .row
                .col-10.mb-1
                  b-pagination.float-left(
                    size="sm"
                    hide-ellipsis
                    :total-rows="totalRow"
                    :per-page="getPageSize"
                    v-model="currentPage"
                    @input="changedPage($event)")
                .col-2.mb-1
                  b-input-group(:prepend="$t('ui.page_size')" size="sm")
                    b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
                .col-12(style="max-height: 70vh; overflow: hidden;")
                  .clusterize-scroll.table-responsive
                    table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList(style="width:185% !important;")
                      thead.thead-light
                        tr
                          th.text-center(width="2%")
                            span #
                          th(width="3%" @click="sortOrder('account_id')")
                            span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                            .float-right
                              i(:class="changeSortKey('account_id')")
                          th.text-right(width="5%" @click="sortOrder('turnover')")
                            span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                            .float-right
                              i(:class="changeSortKey('turnover')")
                          th.text-right(width="5%" @click="sortOrder('valid_turnover')")
                            span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                            .float-right
                              i(:class="changeSortKey('valid_turnover')")
                          th.text-right(width="5%" @click="sortOrder('deposit_amount')")
                            span(:title="$t('ui.deposit_amount')") {{ $t('ui.deposit_amount') }}
                            .float-right
                              i(:class="changeSortKey('deposit_amount')")
                          th.text-right(width="4%" @click="sortOrder('deposit_count')")
                            span(:title="$t('ui.deposit_count')") {{ $t('ui.short.deposit_count') }}
                            .float-right
                              i(:class="changeSortKey('deposit_count')")
                          th.text-right(width="6%" @click="sortOrder('withdrawal_amount')")
                            span(:title="$t('ui.withdrawal_amount')") {{ $t("ui.withdrawal_amount") }}
                            .float-right
                              i(:class="changeSortKey('withdrawal_amount')")
                          th.text-right(width="4%" @click="sortOrder('withdrawal_count')")
                            span(:title="$t('ui.withdrawal_count')") {{ $t('ui.short.withdrawal_count') }}
                            .float-right
                              i(:class="changeSortKey('withdrawal_count')")
                          th.text-right(width="5%" @click="sortOrder('d_w_diff')")
                            span(:title="$t('ui.deposit_withdrawal_different')") {{ $t("ui.short.deposit_withdrawal_different") }}
                            .float-right
                              i(:class="changeSortKey('d_w_diff')")
                          th.text-right(width="5%" @click="sortOrder('winlose')")
                            span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                            .float-right
                              i(:class="changeSortKey('winlose')")
                          th.text-right(width="5%" @click="sortOrder('bonus_amount')")
                            span(:title="$t('ui.bonus_amount')") {{ $t("ui.bonus_amount") }}
                            .float-right
                              i(:class="changeSortKey('bonus_amount')")
                          th.text-right(width="5%" @click="sortOrder('ngr')")
                            span(:title="$t('ui.ngr')") {{ $t("ui.ngr") }}
                            .float-right
                              i(:class="changeSortKey('ngr')")
                          th.text-right(width="6%" @click="sortOrder('adjustment_amount')")
                            span(:title="$t('ui.adjustment_amount')") {{ $t("ui.adjustment_amount") }}
                            .float-right
                              i(:class="changeSortKey('adjustment_amount')")
                          th.text-right(width="4%" @click="sortOrder('verified_count')")
                            span(:title="$t('ui.verified_count')") {{ $t("ui.short.verified_count") }}
                            .float-right
                              i(:class="changeSortKey('verified_count')")
                          th.text-right(width="5%" @click="sortOrder('active_member')")
                            span(:title="$t('ui.active_member')") {{ $t("ui.short.active_member") }}
                            .float-right
                              i(:class="changeSortKey('active_member')")
                          th.text-right(width="5%" @click="sortOrder('referee_count')")
                            span(:title="$t('ui.referee_count')") {{ $t("ui.referee_count") }}
                            .float-right
                              i(:class="changeSortKey('referee_count')")
                          th.text-right(width="4%" @click="sortOrder('signup_count')")
                            span(:title="$t('ui.signup_count')") {{ $t("ui.short.signup_count") }}
                            .float-right
                              i(:class="changeSortKey('signup_count')")
                          th.text-right(width="4%" @click="sortOrder('ftd_count')")
                            span(:title="$t('ui.ftd_count')") {{ $t("ui.short.ftd_count") }}
                            .float-right
                              i(:class="changeSortKey('ftd_count')")
                          th.text-right(width="4%" @click="sortOrder('ftd_amount')")
                            span(:title="$t('ui.ftd_amount')") {{ $t("ui.short.ftd_amount") }}
                            .float-right
                              i(:class="changeSortKey('ftd_amount')")
                          th.text-right(width="5%" @click="sortOrder('unique_login_count')")
                            span(:title="$t('ui.unique_login_count')") {{ $t("ui.short.unique_login_count") }}
                            .float-right
                              i(:class="changeSortKey('unique_login_count')")
                          th.text-right(width="4%" @click="sortOrder('unique_deposit_count')")
                            span(:title="$t('ui.unique_deposit_count')") {{ $t("ui.short.unique_deposit_count") }}
                            .float-right
                              i(:class="changeSortKey('unique_deposit_count')")
                          th.text-right(width="4%" @click="sortOrder('unique_withdrawal_count')")
                            span(:title="$t('ui.unique_withdrawal_count')") {{ $t("ui.short.unique_withdrawal_count") }}
                            .float-right
                              i(:class="changeSortKey('unique_withdrawal_count')")
                          th.text-right(width="5%" @click="sortOrder('second_deposit_count')")
                            span(:title="$t('ui.second_deposit_count')") {{ $t("ui.short.second_deposit_count") }}
                            .float-right
                              i(:class="changeSortKey('second_deposit_count')")
                      tbody.clusterize-content
                        tr(v-if="statementList.length == 0")
                          td(colspan="23").text-center
                            span {{ $t('message.no_data_available') }}
                        tr(v-for="(item, index) in statementList")
                          td.text-center
                            span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.account_id")
                              b-link.text-decoration-none(href="javascript:void(0);" @click="pageMode(item.account_id, 0)") {{ item.account_id }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.turnover)" :title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.valid_turnover)" :title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.deposit_amount)" :title="$n(item.deposit_amount, 'currency')") {{ $n(item.deposit_amount, 'currency') }}
                          td.text-right
                            //- span.font-weight-bold.small.text-warning(v-if="item.unique_deposit_count > 0" :title="$n(item.unique_deposit_count, 'integer')") ({{ $n(item.unique_deposit_count, 'integer') }}) 
                            span.font-weight-bold(:title="$n(item.deposit_count, 'integer')") {{ $n(item.deposit_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.withdrawal_amount * -1)" :title="$n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency')") {{ $n(item.withdrawal_amount > 0 ? item.withdrawal_amount * -1 : item.withdrawal_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.withdrawal_count, 'integer')") {{ $n(item.withdrawal_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:class="[item.d_w_diff < 0 ? 'text-danger' : 'text-info']" :title="$n(item.d_w_diff, 'currency')") {{ $n(item.d_w_diff, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.winlose)" :title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)" :title="$n(item.bonus_amount, 'currency')") {{ $n(item.bonus_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(:class="[item.ngr < 0 ? 'text-danger' : 'text-info']" :title="$n(item.ngr, 'currency')") {{ $n(item.ngr, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:class="[item.adjustment_amount < 0 ? 'text-danger' : 'text-info']" :title="$n(item.adjustment_amount, 'currency')") {{ $n(item.adjustment_amount, 'currency') }}
                          td.text-right
                            span.font-weight-bold(v-if="item.verified_count == 0" :class="$helpers.fontClassName(item.verified_count)" :title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
                            span.font-weight-bold(v-if="item.verified_count != 0")
                              template(v-if="showActionButton('registeredmember')")
                                b-link.font-weight-bold(href="javascript:void(0);" @click="redirectToRegisteredMember(item)" :class="$helpers.fontClassName(item.verified_count, true)" :title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
                              template(v-else)
                                span.font-weight-bold(href="javascript:void(0);" :class="$helpers.fontClassName(item.verified_count, true)" :title="$n(item.verified_count, 'integer')") {{ $n(item.verified_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.active_member, 'integer')") {{ $n(item.active_member, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.referee_count, 'integer')") {{ $n(item.referee_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:title="$n(item.signup_count, 'integer')") {{ $n(item.signup_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(v-if="item.ftd_count == 0" :class="$helpers.fontClassName(item.ftd_count)" :title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
                            span.font-weight-bold(v-if="item.ftd_count != 0")
                              template(v-if="showActionButton('firstdeposit')")
                                b-link.font-weight-bold(href="javascript:void(0);" @click="redirectToFirstDeposit(item)" :class="$helpers.fontClassName(item.ftd_count, true)" :title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
                              template(v-else)
                                span.font-weight-bold(href="javascript:void(0);" :class="$helpers.fontClassName(item.ftd_count, true)" :title="$n(item.ftd_count, 'integer')") {{ $n(item.ftd_count, 'integer') }}
                          td.text-right
                            span.font-weight-bold(:class="$helpers.fontClassName(item.ftd_amount)" :title="$n(item.ftd_amount, 'currency')") {{ $n(item.ftd_amount, 'currency') }}
                          td.text-right
                            template(v-if="item.unique_login_count > 0")
                              b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="item.unique_login_count" @click="pageMode(item.account_id, 1)") {{ item.unique_login_count }}
                            template(v-else)
                              span.font-weight-bold.text-info(:title="item.unique_login_count") {{ item.unique_login_count }}
                          td.text-right
                            //- template(v-if="item.unique_deposit_count > 0")
                            //-   b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="item.unique_deposit_count" @click="pageMode(item.account_id, 2)") {{ item.unique_deposit_count }}
                            //- template(v-else)
                            span.font-weight-bold.text-info(:title="item.unique_deposit_count") {{ item.unique_deposit_count }}
                          td.text-right
                            template(v-if="item.unique_withdrawal_count > 0")
                              b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="item.unique_withdrawal_count" @click="pageMode(item.account_id, 2)") {{ item.unique_withdrawal_count }}
                            template(v-else)
                              span.font-weight-bold.text-info(:title="item.unique_withdrawal_count") {{ item.unique_withdrawal_count }}                              
                          td.text-right
                            template(v-if="item.second_deposit_count > 0")
                              b-link.font-weight-bold.text-info.text-decoration-none(href="javascript:void(0);" :title="item.second_deposit_count" @click="pageMode(item.account_id, 3)") {{ item.second_deposit_count }}
                            template(v-else)
                              span.font-weight-bold.text-info(:title="item.second_deposit_count") {{ item.second_deposit_count }} 
                        tr(v-if="showTotal")
                          td.text-right(colspan="2")
                            div {{ $t("ui.sub_total") }}
                            div {{ $t("ui.grand_total") }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalDepositAmount)" :title="$n(subTotalDepositAmount, 'currency')") {{ $n(subTotalDepositAmount, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositAmount)" :title="$n(grandTotalDepositAmount, 'currency')") {{ $n(grandTotalDepositAmount, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalDepositCount)" :title="$n(subTotalDepositCount, 'integer')") {{ $n(subTotalDepositCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositCount)" :title="$n(grandTotalDepositCount, 'integer')") {{ $n(grandTotalDepositCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="[subTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency')") {{ $n(subTotalWithdrawalAmount > 0 ? subTotalWithdrawalAmount * -1 : subTotalWithdrawalAmount, 'currency') }}
                            .font-weight-bold(:class="[grandTotalWithdrawalAmount == 0 ? 'text-primary' : 'text-danger']" :title="$n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency')") {{ $n(grandTotalWithdrawalAmount > 0 ? grandTotalWithdrawalAmount * -1 : grandTotalWithdrawalAmount, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWithdrawalCount)" :title="$n(subTotalWithdrawalCount, 'integer')") {{ $n(subTotalWithdrawalCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalWithdrawalCount)" :title="$n(grandTotalWithdrawalCount, 'integer')") {{ $n(grandTotalWithdrawalCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalDepositWithdrawalDifferent)" :title="$n(subTotalDepositWithdrawalDifferent, 'currency')") {{ $n(subTotalDepositWithdrawalDifferent, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalDepositWithdrawalDifferent)" :title="$n(grandTotalDepositWithdrawalDifferent, 'currency')") {{ $n(grandTotalDepositWithdrawalDifferent, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalBonusAmount)" :title="$n(subTotalBonusAmount, 'currency')") {{ $n(subTotalBonusAmount, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalBonusAmount)" :title="$n(grandTotalBonusAmount, 'currency')") {{ $n(grandTotalBonusAmount, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalNgr)" :title="$n(subTotalNgr, 'currency')") {{ $n(subTotalNgr, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalNgr)" :title="$n(grandTotalNgr, 'currency')") {{ $n(grandTotalNgr, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAdjustmentAmount)" :title="$n(subTotalAdjustmentAmount, 'currency')") {{ $n(subTotalAdjustmentAmount, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalAdjustmentAmount)" :title="$n(grandTotalAdjustmentAmount, 'currency')") {{ $n(grandTotalAdjustmentAmount, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalVerifiedCount)" :title="$n(subTotalVerifiedCount, 'integer')") {{ $n(subTotalVerifiedCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalVerifiedCount)" :title="$n(grandTotalVerifiedCount, 'integer')") {{ $n(grandTotalVerifiedCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalActiveMember)" :title="$n(subTotalActiveMember, 'integer')") {{ $n(subTotalActiveMember, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalActiveMember)" :title="$n(grandTotalActiveMember, 'integer')") {{ $n(grandTotalActiveMember, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalRefereeCount)" :title="$n(subTotalRefereeCount, 'integer')") {{ $n(subTotalRefereeCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalRefereeCount)" :title="$n(grandTotalRefereeCount, 'integer')") {{ $n(grandTotalRefereeCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalSignupCount)" :title="$n(subTotalSignupCount, 'integer')") {{ $n(subTotalSignupCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalSignupCount)" :title="$n(grandTotalSignupCount, 'integer')") {{ $n(grandTotalSignupCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalFtdCount)" :title="$n(subTotalFtdCount, 'integer')") {{ $n(subTotalFtdCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdCount)" :title="$n(grandTotalFtdCount, 'integer')") {{ $n(grandTotalFtdCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalFtdAmount)" :title="$n(subTotalFtdAmount, 'currency')") {{ $n(subTotalFtdAmount, 'currency') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalFtdAmount)" :title="$n(grandTotalFtdAmount, 'currency')") {{ $n(grandTotalFtdAmount, 'currency') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalUniqueLoginCount)" :title="$n(subTotalUniqueLoginCount, 'integer')") {{ $n(subTotalUniqueLoginCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueLoginCount)" :title="$n(grandTotalUniqueLoginCount, 'integer')") {{ $n(grandTotalUniqueLoginCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalUniqueDepositCount)" :title="$n(subTotalUniqueDepositCount, 'integer')") {{ $n(subTotalUniqueDepositCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueDepositCount)" :title="$n(grandTotalUniqueDepositCount, 'integer')") {{ $n(grandTotalUniqueDepositCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalUniqueWithdrawalCount)" :title="$n(subTotalUniqueWithdrawalCount, 'integer')") {{ $n(subTotalUniqueWithdrawalCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalUniqueWithdrawalCount)" :title="$n(grandTotalUniqueWithdrawalCount, 'integer')") {{ $n(grandTotalUniqueWithdrawalCount, 'integer') }}
                          td.text-right
                            .font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalSecondDepositCount)" :title="$n(subTotalSecondDepositCount, 'integer')") {{ $n(subTotalSecondDepositCount, 'integer') }}
                            .font-weight-bold(:class="$helpers.fontClassName(grandTotalSecondDepositCount)" :title="$n(grandTotalSecondDepositCount, 'integer')") {{ $n(grandTotalSecondDepositCount, 'integer') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import jsonToExcelFull from "@/library/jsonToExcelFull.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import dailyLedgerMember from "@/views/report/_dailyLedgerMember.vue";
import uniqueLogin from "@/views/report/_uniqueLogin.vue";
import uniqueWithdrawal from "@/views/report/_uniqueWithdrawal.vue";
import secondDeposit from "@/views/report/_secondDeposit.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcelFull,
    dailyLedgerMember,
    uniqueLogin,
    uniqueWithdrawal,
    secondDeposit
  },
  data: () => ({
    loading2: false,
    loading: false,
    selectedOperatorID: null,
    grandTotalList: [],
    statementList: [],
    statementListFull: [],
    currentPage: 1,
    totalRow: 0,
    searchID: "",
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalDepositAmount: 0,
    grandTotalDepositAmount: 0,
    subTotalDepositCount: 0,
    grandTotalDepositCount: 0,
    subTotalWithdrawalAmount: 0,
    grandTotalWithdrawalAmount: 0,
    subTotalWithdrawalCount: 0,
    grandTotalWithdrawalCount: 0,
    subTotalBonusAmount: 0,
    grandTotalBonusAmount: 0,
    subTotalAdjustmentAmount: 0,
    grandTotalAdjustmentAmount: 0,
    subTotalActiveMember: 0,
    grandTotalActiveMember: 0,
    subTotalRefereeCount: 0,
    grandTotalRefereeCount: 0,
    subTotalSignupCount: 0,
    grandTotalSignupCount: 0,
    subTotalVerifiedCount: 0,
    grandTotalVerifiedCount: 0,
    subTotalFtdCount: 0,
    grandTotalFtdCount: 0,
    subTotalFtdAmount: 0,
    grandTotalFtdAmount: 0,
    subTotalUniqueLoginCount: 0,
    grandTotalUniqueLoginCount: 0,
    subTotalUniqueDepositCount: 0,
    grandTotalUniqueDepositCount: 0,
    subTotalUniqueWithdrawalCount: 0,
    grandTotalUniqueWithdrawalCount: 0,
    subTotalSecondDepositCount: 0,
    grandTotalSecondDepositCount: 0,
    subTotalDepositWithdrawalDifferent: 0,
    grandTotalDepositWithdrawalDifferent: 0,
    subTotalNgr: 0,
    grandTotalNgr: 0,
    showTotal: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "account_id",
    sortType: "desc",
    mode: 0 // 0 = ledgermember , 1 = uniquelogin, 2 = uniquewithdrawal, 3 = seconddeposit
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      if(this.isOperator) {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.searchID = this.accountID
        this.getList(true);
      } else {
        if (this.$store.getters.reportStatement.operator_id != null)
          this.searchID = this.$store.getters.reportStatement.operator_id;

        if (this.$store.getters.reportStatement.start_date && this.$store.getters.reportStatement.end_date) {
          this.dateRange.startDate = this.$store.getters.reportStatement.start_date;
          this.dateRange.endDate = this.$store.getters.reportStatement.end_date;
        } else {
          this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
          this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
        }

        this.getList(true);
      }
    }
  },
  methods: {
    redirect(id) {
      this.selectedOperatorID = null;
      this.getList(true);
    },
    getPageName(mode) {
      switch(mode){
        case 0:
          return this.$t('ui.daily_ledger_member')
        case 1:
          return this.$t('ui.unique_login')
        case 2:
          return this.$t('ui.unique_withdrawal')
        case 3:
          return this.$t('ui.second_deposit')
      }
    },
    pageMode(id, e) {
      this.selectedOperatorID = id
      this.mode = e
      var vm = this
      $(document).ready(function(){
        switch(e) {
          case 1:
            vm.$refs.uniqueLogin.getList()
            break
          case 2:
            vm.$refs.uniqueWithdrawal.getList()
            break
          case 3:
            vm.$refs.secondDeposit.getList()
            break
          default:
            vm.$refs.dailyLedgerMember.getList(true);
            break
        }
      });
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    clearDateRange() {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getStatement(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getList(true);
    },
    getList(isSearch) {
      this.getStatement(isSearch);
      if (this.$helpers.showExportAll(this.dateRange) == true) {
        this.getStatementFull(isSearch);
      }
    },
    setReportStatementParam() {
      var json = {
        operator_id: this.searchID.trim(),
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.$store.dispatch("user/setReportStatementParam", json);
    },
    redirectToFirstDeposit: function(item, type) {
      var json = {
        operator_id: this.searchID,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setReportStatementParam", json);
      this.$router.push("/report/firstDeposit");
    },
    redirectToRegisteredMember: function(item, type) {
      var json = {
        operator_id: this.searchID,
        member_id: this.$store.getters.reportStatement.member_id,
        start_date: item.working_date,
        end_date: item.working_date
      };

      this.$store.dispatch("user/setReportStatementParam", json);
      this.$router.push("/report/registeredMember");
    },
    getStatement: function(isSearch) {
      if (this.checkDateRange()) {

        // if (this.searchID.trim() == '') {
        //   this.clearTotal();
        //   this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.operatorIdRequired"), "error");
        //   return;
        // }

        this.setReportStatementParam();

        let url = config.dailyLedgerOperatorUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.statement.length > 0) {
                    this.showTotal = true;
                    response.data.ds.statement.forEach(value => {
                      this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                      this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                      this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                      this.subTotalDepositAmount = parseFloat(this.subTotalDepositAmount) + parseFloat(value["deposit_amount"]);
                      this.subTotalDepositCount = parseInt(this.subTotalDepositCount) + parseInt(value["deposit_count"]);
                      this.subTotalWithdrawalAmount = parseFloat(this.subTotalWithdrawalAmount) + parseFloat(value["withdrawal_amount"]);
                      this.subTotalWithdrawalCount = parseInt(this.subTotalWithdrawalCount) + parseInt(value["withdrawal_count"]);
                      this.subTotalBonusAmount = parseFloat(this.subTotalBonusAmount) + parseFloat(value["bonus_amount"]);
                      this.subTotalAdjustmentAmount = parseFloat(this.subTotalAdjustmentAmount) + parseFloat(value["adjustment_amount"]);
                      this.subTotalRefereeCount = parseInt(this.subTotalRefereeCount) + parseInt(value["referee_count"]);
                      this.subTotalSignupCount = parseInt(this.subTotalSignupCount) + parseInt(value["signup_count"]);
                      this.subTotalVerifiedCount = parseInt(this.subTotalVerifiedCount) + parseInt(value["verified_count"]);
                      this.subTotalActiveMember = parseInt(this.subTotalActiveMember) + parseInt(value["active_member"]);
                      this.subTotalFtdCount = parseInt(this.subTotalFtdCount) + parseInt(value["ftd_count"]);
                      this.subTotalFtdAmount = parseFloat(this.subTotalFtdAmount) + parseFloat(value["ftd_amount"]);
                      this.subTotalUniqueLoginCount = parseInt(this.subTotalUniqueLoginCount) + parseInt(value["unique_login_count"]);
                      this.subTotalUniqueDepositCount = parseInt(this.subTotalUniqueDepositCount) + parseInt(value["unique_deposit_count"]);
                      this.subTotalUniqueWithdrawalCount = parseInt(this.subTotalUniqueWithdrawalCount) + parseInt(value["unique_withdrawal_count"]);
                      this.subTotalSecondDepositCount = parseInt(this.subTotalSecondDepositCount) + parseInt(value["second_deposit_count"]);
                      this.subTotalDepositWithdrawalDifferent = parseFloat(this.subTotalDepositWithdrawalDifferent) + parseFloat(value["d_w_diff"]);
                      this.subTotalNgr = parseFloat(this.subTotalNgr) + parseFloat(value["ngr"]);
                    });


                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                      this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                      this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                      this.grandTotalDepositAmount = response.data.ds.grand_total[0]["deposit_amount"];
                      this.grandTotalDepositCount = response.data.ds.grand_total[0]["deposit_count"];
                      this.grandTotalWithdrawalAmount = response.data.ds.grand_total[0]["withdrawal_amount"];
                      this.grandTotalWithdrawalCount = response.data.ds.grand_total[0]["withdrawal_count"];
                      this.grandTotalBonusAmount = response.data.ds.grand_total[0]["bonus_amount"];
                      this.grandTotalAdjustmentAmount = response.data.ds.grand_total[0]["adjustment_amount"];
                      this.grandTotalActiveMember = response.data.ds.grand_total[0]["active_member"];
                      this.grandTotalRefereeCount = response.data.ds.grand_total[0]["referee_count"];
                      this.grandTotalSignupCount = response.data.ds.grand_total[0]["signup_count"];
                      this.grandTotalVerifiedCount = response.data.ds.grand_total[0]["verified_count"];
                      this.grandTotalFtdCount = response.data.ds.grand_total[0]["ftd_count"];
                      this.grandTotalFtdAmount = response.data.ds.grand_total[0]["ftd_amount"];
                      this.grandTotalUniqueLoginCount = response.data.ds.grand_total[0]["unique_login_count"];
                      this.grandTotalUniqueDepositCount = response.data.ds.grand_total[0]["unique_deposit_count"];
                      this.grandTotalUniqueWithdrawalCount = response.data.ds.grand_total[0]["unique_withdrawal_count"];
                      this.grandTotalSecondDepositCount = response.data.ds.grand_total[0]["second_deposit_count"];
                      this.grandTotalDepositWithdrawalDifferent = response.data.ds.grand_total[0]["d_w_diff"];
                      this.grandTotalNgr = response.data.ds.grand_total[0]["ngr"];
                    }

                    this.statementList = response.data.ds.statement;
                    this.totalRow = response.data.ds.statement.length > 0 ? this.statementList[0]["totalrows"] : 0
                  } else {
                    this.clearTotal()
                  }
                } else {
                  this.clearTotal()
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotal();
        this.statementList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getStatementFull: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyLedgerOperatorUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.searchID.trim(),
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.statementListFull = response.data.ds.statement;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    clearTotal() {
      this.showTotal = false
      this.statementList = []
      this.totalRow = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalDepositAmount = 0
      this.grandTotalDepositAmount = 0
      this.subTotalDepositCount = 0
      this.grandTotalDepositCount = 0
      this.subTotalWithdrawalAmount = 0
      this.grandTotalWithdrawalAmount = 0
      this.subTotalWithdrawalCount = 0
      this.grandTotalWithdrawalCount = 0
      this.subTotalBonusAmount = 0
      this.grandTotalBonusAmount = 0
      this.subTotalAdjustmentAmount = 0
      this.grandTotalAdjustmentAmount = 0
      this.subTotalActiveMember = 0
      this.grandTotalActiveMember = 0
      this.subTotalRefereeCount = 0
      this.grandTotalRefereeCount = 0
      this.subTotalSignupCount = 0
      this.grandTotalSignupCount = 0
      this.subTotalVerifiedCount = 0
      this.grandTotalVerifiedCount = 0
      this.subTotalFtdCount = 0
      this.grandTotalFtdCount = 0
      this.subTotalFtdAmount = 0
      this.grandTotalFtdAmount = 0
      this.subTotalUniqueLoginCount = 0,
      this.grandTotalUniqueLoginCount = 0,
      this.subTotalUniqueDepositCount = 0,
      this.grandTotalUniqueDepositCount = 0,
      this.subTotalUniqueWithdrawalCount = 0,
      this.grandTotalUniqueWithdrawalCount = 0,
      this.subTotalSecondDepositCount = 0,
      this.grandTotalSecondDepositCount = 0
      this.subTotalDepositWithdrawalDifferent = 0,
      this.grandTotalDepositWithdrawalDifferent = 0
      this.subTotalNgr = 0,
      this.grandTotalNgr = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getStatement(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getStatement();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>